module.exports = __webpack_public_path__ + "img/ZEC-alt.3230ac53.svg";